/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ManualList,
    ManualListFromJSON,
    ManualListToJSON,
} from '../models';

export interface GetManualPdfRequest {
    manualId: number;
}

/**
 * 
 */
export class ManualApi extends runtime.BaseAPI {

    /**
     * マニュアルPDF
     */
    async getManualPdfRaw(requestParameters: GetManualPdfRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.manualId === null || requestParameters.manualId === undefined) {
            throw new runtime.RequiredError('manualId','Required parameter requestParameters.manualId was null or undefined when calling getManualPdf.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manuals/{manual_id}.pdf`.replace(`{${"manual_id"}}`, encodeURIComponent(String(requestParameters.manualId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * マニュアルPDF
     */
    async getManualPdf(requestParameters: GetManualPdfRequest): Promise<Blob> {
        const response = await this.getManualPdfRaw(requestParameters);
        return await response.value();
    }

    /**
     * マニュアルリスト
     */
    async getManualsRaw(): Promise<runtime.ApiResponse<ManualList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/manuals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ManualListFromJSON(jsonValue));
    }

    /**
     * マニュアルリスト
     */
    async getManuals(): Promise<ManualList> {
        const response = await this.getManualsRaw();
        return await response.value();
    }

}
